import * as React from 'react'

import { EmployeesShowPageDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import TaskElement from 'modules/tasks/components/TaskElement'
import { TaskIdentifier } from 'modules/tasks/lib/task'

const Component: React.FC = () => {
  const { navigation: navigation } = useNavigation()

  const { id, taskId } = useStrictParams<'id' | 'taskId'>()
  const back = navigation.employees.id.tasks.fullPath({ id })

  const { data, loading } = useQuery(EmployeesShowPageDocument, {
    variables: {
      taskId: Number(taskId),
    },
  })

  const customResourceFieldsData =
    compact(data?.customFields.resourceFieldsConnection.edges.map((edge) => edge.node)) ?? []

  const customValuesData =
    data?.tasks.tasksConnection.edges[0]?.node?.affecteesConnection.edges[0]?.node?.employee?.valuesConnection.edges.map(
      (edge) => edge.node
    ) ?? []

  const canEmployeeManageAnyEmployeeFolder =
    data?.documents._policies.employeeManageAnyEmployeeFolder.can ?? false

  // Show single task from employee page
  return (
    <TaskElement
      taskId={Number(taskId)}
      back={back}
      identifier={TaskIdentifier.Single}
      canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
      loading={loading}
      customResourceFieldsData={customResourceFieldsData}
      customValuesData={customValuesData}
    />
  )
}

export default Component
